<template>
    <span v-if="user">
        <v-avatar v-if="avatar" class="mr-1" :image="avatar.url" density="compact" />
        <v-avatar v-else class="mr-1" icon="mdi-account-circle" density="compact" />
        <router-link v-if="to" :to="to">{{ name }}</router-link>
    </span>
    <span v-else-if="fallbackName">
        <v-avatar class="mr-1" icon="mdi-account-circle" density="compact" />
        {{ fallbackName }}
    </span>
</template>
<script setup lang="ts">
import { UserId } from "@/api/users";
import { useUserLookups } from "@/queries/users";
import { computed } from "vue";

const props = defineProps<{
    userId: UserId;
    /** Shown unlinked when the user is not in the internal user list (portal reporters). */
    fallbackName?: string | null | undefined;
}>();

const userLookups = useUserLookups();
const user = computed(() => userLookups.get(props.userId));
const avatar = computed(() =>
    user.value && user.value.avatarId ? userLookups.getAvatar(user.value.avatarId) : undefined
);

const to = computed(() =>
    user.value ? { name: "UserView", params: { userId: user.value.userName } } : undefined
);

const name = computed(() => user.value?.displayName || user.value?.userName);
</script>
